<template>
  <!-- 多项填空 -->
  <div>
    <p v-show="isError" style="color: rgb(247, 73, 69)">{{ errorText }}</p>
    <template v-for="(item, index) in newRowData.questionDetails.issue.fillContext">
      <div class="flex justify-start">
        <h5 class="flex-shrink-0" style="max-width: 120px">
          {{ item.content.text }}
        </h5>
        <el-input
          v-model="newRowData.items[index] && newRowData.items[index].value"
          @focus="onFocus($event)"
          @blur="onBlur($event, item, index)"
          placeholder="请填写"
          @input="changeMatrixInput($event, newRowData, index)"
        ></el-input>
      </div>
    </template>
  </div>
</template>

<script>
import '../public/style.css'
import { checkOtherVal, saveArr } from '../public/index.js'
import Vue from 'vue'
export default {
  name: 'MultipleBlanks',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      errorText: '',
      isError: false,
      oldInputVal: ''
    }
  },
  computed: {
    newRowData() {
      this.handleData()
      return this.rowData
    }
  },
  methods: {
    // 矩阵填空题 input事件
    changeMatrixInput(val, row, index) {
      row.items[index].value = row.items[index] ? val : ''
    },
    // saveArr(){
    //   let ids = this.updateArr.indexOf(this.rowData)
    //   if(ids === -1){
    //     this.updateArr.push(this.rowData)
    //   }
    // },
    onFocus(e) {
      this.oldInputVal = e.target.value
    },
    onBlur(e, item, index) {
      let res = this.checkOtherVal(e.target.value, item) // 校验
      this.isError = res
      if (res) {
        this.newRowData.items[index].value = this.newRowData.items[index] ? this.oldInputVal : ''
      }
      this.saveArr()
    },
    // 校验
    checkOtherVal,
    saveArr,
    handleData() {
      // console.log(this.rowData);
      // 2021-10-01 当必填项目的答案数量与填空数量对不上时候，按顺序补全
      // 防止整体设置成必填，但某一个选项是非必填

      const fill = this.rowData.questionDetails.issue.fillContext
      const f_ids = fill.map(item => item.id)
      const items = this.rowData.items
      const i_ids = items.map(item => item.optionId)

      const newItems = f_ids.map(id => {
        const itemCopy = {
          colId: null,
          optionId: '',
          photos: null,
          rowId: null,
          value: ''
        }
        itemCopy.optionId = id
        if (i_ids.includes(id)) {
          itemCopy.value = items.find(item => item.optionId === id).value
          return itemCopy
        } else {
          return itemCopy
        }
      })
      // console.log(Vue.observable(newItems));
      this.rowData.items = Vue.observable(newItems)
    }
  }
}
</script>

<style lang="scss" scoped></style>
